import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Input, Label } from "../design-system/components/input/Input";
import { Button } from "../design-system/components/button/Button";
import api from "../services/api";


export default function NovaSenha(){

  const { token } = useParams();

  const navigate = useNavigate();


  const [senha, setSenha] = useState("");
  const [confirmarSenha, setConfirmarSenha] = useState("");


  async function handleSubmit(e){

    e.preventDefault();


    if(senha !== confirmarSenha){

      alert("As senhas não conferem");
      return;

    }


    try {

      const resposta = await api.post(
        "/auth/redefinir-senha.php",
        {
          token: token,
          senha: senha
        }
      );


      console.log(resposta.data);


      if(resposta.data.status === "ok"){

        alert("Senha alterada com sucesso");

        navigate("/login");

      }else{

        alert(resposta.data.mensagem);

      }


    } catch(error){

      console.error(error);

      alert("Erro ao alterar senha");

    }


  }


  return (

    <div className="
      min-h-screen
      bg-background
      flex
      items-center
      justify-center
      px-6
    ">


      <div className="
        w-full
        max-w-[400px]
        bg-white
        border
        border-border
        p-8
        rounded-card
        shadow-md
        space-y-6
      ">


        <div className="text-center">

          <div className="
            w-12
            h-12
            rounded-xl
            bg-primary
            flex
            items-center
            justify-center
            text-white
            text-2xl
            mx-auto
            mb-3
          ">
            S
          </div>


          <h1 className="
            text-h3
            font-bold
            text-text-primary
          ">
            Criar nova senha
          </h1>


          <p className="
            text-caption
            text-text-secondary
            mt-2
          ">
            Digite sua nova senha abaixo.
          </p>

        </div>



        <form 
          onSubmit={handleSubmit}
          className="space-y-4"
        >


          <div>

            <Label htmlFor="senha" required>
              Nova senha
            </Label>


            <Input
              id="senha"
              type="password"
              placeholder="••••••••"
              required
              value={senha}
              onChange={(e)=>setSenha(e.target.value)}
            />

          </div>



          <div>

            <Label htmlFor="confirmar" required>
              Confirmar nova senha
            </Label>


            <Input
              id="confirmar"
              type="password"
              placeholder="••••••••"
              required
              value={confirmarSenha}
              onChange={(e)=>setConfirmarSenha(e.target.value)}
            />

          </div>



          <Button 
            type="submit"
            className="w-full"
          >
            Salvar nova senha
          </Button>


        </form>


      </div>


    </div>

  );

}